var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5547,
    cy: 24.5098,
    rx: 25,
    ry: 24.5098,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3195_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5547 40C17.2717 40 10.5547 33.283 10.5547 25C10.5547 16.717 17.2717 10 25.5547 10C33.8377 10 40.5547 16.717 40.5547 25C40.5547 33.283 33.8377 40 25.5547 40Z",
    fill: "url(#paint0_linear_3195_53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5545 16.606C28.2875 16.606 28.6115 16.615 29.6915 16.666C30.6905 16.711 31.2335 16.879 31.5935 17.02C32.0705 17.206 32.4125 17.428 32.7695 17.785C33.1265 18.142 33.3485 18.484 33.5345 18.961C33.6755 19.321 33.8405 19.864 33.8885 20.863C33.9365 21.943 33.9485 22.267 33.9485 25C33.9485 27.733 33.9395 28.057 33.8885 29.137C33.8435 30.136 33.6755 30.679 33.5345 31.039C33.3485 31.516 33.1265 31.858 32.7695 32.215C32.4125 32.572 32.0705 32.794 31.5935 32.98C31.2335 33.121 30.6905 33.286 29.6915 33.334C28.6115 33.382 28.2875 33.394 25.5545 33.394C22.8215 33.394 22.4975 33.385 21.4175 33.334C20.4185 33.289 19.8755 33.121 19.5155 32.98C19.0385 32.794 18.6965 32.572 18.3395 32.215C17.9825 31.858 17.7605 31.516 17.5745 31.039C17.4335 30.679 17.2685 30.136 17.2205 29.137C17.1725 28.057 17.1605 27.733 17.1605 25C17.1605 22.267 17.1695 21.943 17.2205 20.863C17.2655 19.864 17.4335 19.321 17.5745 18.961C17.7605 18.484 17.9825 18.142 18.3395 17.785C18.6965 17.428 19.0385 17.206 19.5155 17.02C19.8755 16.879 20.4185 16.714 21.4175 16.666C22.4975 16.615 22.8215 16.606 25.5545 16.606ZM25.5545 14.761C22.7735 14.761 22.4255 14.773 21.3335 14.824C20.2445 14.875 19.5005 15.046 18.8465 15.301C18.1745 15.559 17.6015 15.91 17.0345 16.48C16.4645 17.05 16.1165 17.62 15.8525 18.295C15.6005 18.946 15.4265 19.69 15.3755 20.782C15.3245 21.874 15.3125 22.222 15.3125 25.003C15.3125 27.784 15.3245 28.132 15.3755 29.224C15.4265 30.313 15.5975 31.057 15.8525 31.711C16.1135 32.38 16.4645 32.953 17.0345 33.52C17.6045 34.09 18.1745 34.438 18.8495 34.702C19.5005 34.954 20.2445 35.128 21.3365 35.179C22.4285 35.23 22.7765 35.242 25.5575 35.242C28.3385 35.242 28.6865 35.23 29.7785 35.179C30.8675 35.128 31.6115 34.957 32.2655 34.702C32.9345 34.441 33.5075 34.09 34.0745 33.52C34.6445 32.95 34.9925 32.38 35.2565 31.705C35.5085 31.054 35.6825 30.31 35.7335 29.218C35.7845 28.126 35.7965 27.778 35.7965 24.997C35.7965 22.216 35.7845 21.868 35.7335 20.776C35.6825 19.687 35.5115 18.943 35.2565 18.289C34.9955 17.62 34.6445 17.047 34.0745 16.48C33.5045 15.91 32.9345 15.562 32.2595 15.298C31.6085 15.046 30.8645 14.872 29.7725 14.821C28.6835 14.773 28.3355 14.761 25.5545 14.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5559 19.741C22.6519 19.741 20.2969 22.096 20.2969 25C20.2969 27.904 22.6519 30.259 25.5559 30.259C28.4599 30.259 30.8149 27.904 30.8149 25C30.8149 22.096 28.4599 19.741 25.5559 19.741ZM25.5559 28.414C23.6719 28.414 22.1419 26.887 22.1419 25C22.1419 23.113 23.6719 21.586 25.5559 21.586C27.4399 21.586 28.9699 23.113 28.9699 25C28.9699 26.887 27.4399 28.414 25.5559 28.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0191 20.764C31.6984 20.764 32.2491 20.2133 32.2491 19.534C32.2491 18.8546 31.6984 18.304 31.0191 18.304C30.3398 18.304 29.7891 18.8546 29.7891 19.534C29.7891 20.2133 30.3398 20.764 31.0191 20.764Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3195_53",
    x1: 14.9481,
    y1: 35.6066,
    x2: 36.1613,
    y2: 14.3934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3195_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10.5547 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstgram);
export default __webpack_public_path__ + "static/media/Instgram.ed76130eda794dd87f4617a9fe46f134.svg";
export { ForwardRef as ReactComponent };